/*
 * Limites de upload (Processos e Seletivas parte 2 — R7/D19–D21, 03/09/2026).
 *
 * O teto vivia HARDCODED em dois lugares que não se falavam: 30 MB no
 * `FileUploader` (front) e 50 MB no multer (backend). O cliente subiu o limite
 * para 500 MB e decidiu que vale para TODOS os uploads da plataforma (D20) —
 * não só no Álbum, que é o que motivou o pedido (consequência C4).
 *
 * ⚠️ MAX_FALLBACK_BYTES não é escolha nossa: é o teto do multer
 * (`src/middlewares/fileUpload.js`), o caminho ALTERNATIVO usado quando o PUT
 * direto ao S3 falha (CORS/rede). Acima disso não há plano B — e a mensagem
 * precisa dizer isso, em vez do genérico "não foi possível fazer upload".
 */
export const MAX_UPLOAD_BYTES = 500 * 1024 * 1024;

export const MAX_FALLBACK_BYTES = 50 * 1024 * 1024;

/** "500 MB", "1.5 GB" — para as mensagens não repetirem o número na mão. */
export const formatBytes = (bytes) => {
  const mb = bytes / (1024 * 1024);

  if (mb >= 1024) {
    const gb = mb / 1024;

    return `${Number.isInteger(gb) ? gb : gb.toFixed(1)} GB`;
  }

  return `${Number.isInteger(mb) ? mb : mb.toFixed(1)} MB`;
};
